import React from 'react'
import styles from './Button.scss'
import cx from 'classnames'

export const Button = ({ className, type, children, active, disabled, ...props }) => (
  <div className={cx(className, styles[type], styles.Button, active && styles.active, disabled && styles.disabled)} {...props}>
    <div className={styles.inner}>
      {children}
    </div>
  </div>
)
